window.$ = window.jQuery = require("jquery");
require("./lib/featherlight.min.js");
require('./utils/modernizr.js');

import {setAlerts} from "./alerts.js";
import {faq} from "./utils/faq.js";
import { sharePopup } from './utils/share';

(function () {
  "use strict";
  setAlerts();

  // PNG files need to be included in /web/images/assets/
  faq();
  sharePopup();

  // On Document Ready
  $(document).ready(function () {

    // Main Navigation -------------------------

    // cache jquery elements
    let $header = $('.js-header'),
        $mobileNavToggle = $('.js-mobile-nav-toggle'),
        $navContainers = $('.js-mobile-nav-toggle, .js-mobile-nav-container, .js-secondary-nav-container'),
        $mobileNav = $('.js-mobile-nav');

    // Toggle Mobile Nav Open/Close
    $mobileNavToggle.click(function () {
      $navContainers.toggleClass('open');
      $('body').toggleClass('overflow-hidden');

      // Add event listener (if mobile nav is open) to close menu if outside menu is touched
      if ($navContainers.hasClass('open')) {
        // Set event listeners
        $(document).on('click.mobileNav', function () {
          $mobileNavToggle.click();
        });

        // Allow clicking inside the header element
        $header.on('click.mobileNav', function (e) {
          e.stopPropagation();
        });

      } else {
        // Remove event listeners
        $(document).off('click.mobileNav');
        $header.off('click.mobileNav');
      }
    });

    // Toggle Sub-Menus in Mobile Nav
    $mobileNav.find('a.dropdown-toggle').click(function (e) {
      e.preventDefault();
      $(this).parent('li').toggleClass('open');
    });

    // ------------------------- Main Navigation

  });

})();



// WEBPACK FOOTER //
// ./resources/js/index.js